import { render, staticRenderFns } from "./sonList.vue?vue&type=template&id=119d4a9c&scoped=true&"
import script from "./sonList.vue?vue&type=script&lang=js&"
export * from "./sonList.vue?vue&type=script&lang=js&"
import style0 from "./sonList.vue?vue&type=style&index=0&id=119d4a9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d4a9c",
  null
  
)

export default component.exports